// src/components/chat/ChatSettingsModal.jsx
import React, { useState } from 'react';
import { Modal, Button, ListGroup, Badge, Spinner, Alert } from 'react-bootstrap';
import { useChat } from '../../contexts/ChatContext';
import { useAuth } from '../../contexts/AuthContext';

const ChatSettingsModal = ({ show, onHide, room }) => {
  const { removeParticipant } = useChat();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRemoveParticipant = async (userId) => {
    if (userId === user?.id) return; // нельзя удалить себя через этот метод
    if (!window.confirm('Удалить участника из группы?')) return;
    setLoading(true);
    setError('');
    const success = await removeParticipant(room.id, userId);
    if (!success) {
      setError('Не удалось удалить участника');
    }
    setLoading(false);
  };

  if (!room) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-gear me-2"></i>
          Настройки группы
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <h6>Участники ({room.participants?.length})</h6>
        <ListGroup variant="flush">
          {room.participants?.map(p => (
            <ListGroup.Item key={p.user_id} className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-2">
                <i className="bi bi-person-circle"></i>
                <div>
                  <div>{p.user_name}</div>
                  <Badge bg={p.role === 'admin' ? 'danger' : 'secondary'}>{p.role}</Badge>
                </div>
              </div>
              {p.role !== 'admin' && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleRemoveParticipant(p.user_id)}
                  disabled={loading}
                >
                  <i className="bi bi-x"></i>
                </Button>
              )}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChatSettingsModal;